class NowTime extends HTMLElement {

    connectedCallback() {
        requestAnimationFrame(() => {
            this.timeEl = this.querySelector('.time-line');
            this.dateEl = this.querySelector('.date-line');
            if (!this.timeEl || !this.dateEl) return;
            this.render();
            this.startClock();

        });
    }

    disconnectedCallback() {
        clearTimeout(this.timer);
    }

    startClock() {
        const update = () => {
            this.render();

            // 精准对齐下一秒
            const delay = 1000 - (Date.now() % 1000);

            this.timer = setTimeout(update, delay);
        };

        update();
    }

    render() {
        const now = new Date();

        // 时间
        const h = String(now.getHours()).padStart(2, '0');
        const m = String(now.getMinutes()).padStart(2, '0');
        const s = String(now.getSeconds()).padStart(2, '0');

        const time = `${h}:${m}:${s}`;

        // 避免重复 DOM 更新
        if (this.lastTime !== time) {
            this.timeEl.textContent = time;
            this.lastTime = time;
        }

        // 日期
        const y = now.getFullYear();
        const mo = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');

        const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

        const date = `${y}/${mo}/${d} ${weeks[now.getDay()]}`;

        if (this.lastDate !== date) {
            this.dateEl.textContent = date;
            this.lastDate = date;
        }
    }
}
if (!customElements.get('now-time')) {
    customElements.define('now-time', NowTime);
}


class CircleItem extends HTMLElement {
    connectedCallback() {
        requestAnimationFrame(() => {
            this.percent = Number(this.dataset.number) || 0;
            this.init();
        });
    }
    init() {
        const percent = this.percent;
        const circle = this.querySelector('.progress-bar');
        const text = this.querySelector('.num');
        if (!circle || !text) return;
        const radius = 54;
        const circumference = 2 * Math.PI * radius;
        // 设置总长度
        circle.style.strokeDasharray = circumference;
        // 偏移量
        const offset = circumference * (1 - percent / 100);
        setTimeout(() => {
            circle.style.strokeDashoffset = offset;
        }, 100);
        // 数字动画
        let current = 0;
        this.timer = setInterval(() => {
            current += 1.2;
            if (current >= percent) {
                current = percent;
                clearInterval(this.timer);
            }
            text.innerHTML = ` ${current.toFixed(1)}<span>%</span>`;
        }, 16);

    }
    disconnectedCallback() {
        clearInterval(this.timer);
    }
}
if (!customElements.get('circle-item')) {
    customElements.define('circle-item', CircleItem);
}


// 获取数据
class ReaderItem extends HTMLElement {
    constructor() {
        super();

        //组别赛道数据
        //  所在组
        // GMV目标数
        // GMV达成
        // 利润率
        this.groupTrack = [
            {
                "name": "AMZ-NP",
                "count": 11187485,
                "amount": 5702605.86,
                "type": "yellow",
                "number": 5,
                "value": 0
            },
            {
                "name": "AMZ-ZLX",
                "count": 2313929,
                "amount": 732807.67,
                "type": "purple",
                "number": 4,
                "value": 0
            },
            {
                "name": "DTC-NP",
                "count": 278351,
                "amount": 97375.29,
                "type": "red",
                "number": 4,
                "value": 0
            },
            {
                "name": "TK-NP",
                "count": 312591,
                "amount": 246292.11,
                "type": "green",
                "number": 4,
                "value": 0
            }
        ];

        this.hasInit = false;
    }
    connectedCallback() {
        if (this.hasInit) return;
        this.hasInit = true;
        requestAnimationFrame(() => {
            this.swiperOne = this.querySelector(".one-user-list");
            this.swiperTwo = this.querySelector(".two-user-list");
            this.swiperThree = this.querySelector(".three-user-list");
            this.swiperFour = this.querySelector(".four-user-list");
            this.swiperFive = this.querySelector(".five-user-list");
            this.swiperSix = this.querySelector(".six-user-list");

            if (!this.swiperOne || !this.swiperTwo || !this.swiperThree || !this.swiperFour || !this.swiperFive || !this.swiperSix) {
                console.warn("ReaderItem: required list container not found.");
                return;
            }

            this.init();
        });
    }
    // 初始化数据
    async init() {
        const fetchXls = async function (url) {
            const resp = await fetch(url);
            if (!resp.ok) throw new Error("网络错误: " + resp.status);

            // 转成 ArrayBuffer
            const arrayBuffer = await resp.arrayBuffer();
            const data = new Uint8Array(arrayBuffer);

            // 解析 Excel
            const workbook = XLSX.read(data, { type: "array" });

            // 取第一个 sheet
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            // 转成二维数组（header:1 表示不自动转 JSON key，而是直接数组）
            const rows = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                defval: ""
            });

            const hasValue = (value) => value !== null && value !== undefined && String(value).trim() !== "";
            const rowsForColumnCheck = rows.slice(1).length ? rows.slice(1) : rows;
            const usedColumnIndexes = [];
            rowsForColumnCheck.forEach((row) => {
                row.forEach((cell, index) => {
                    if (hasValue(cell) && !usedColumnIndexes.includes(index)) {
                        usedColumnIndexes.push(index);
                    }
                });
            });

            return rows
                .map((row) => usedColumnIndexes.map((index) => row[index]))
                .filter((row) => row.some(hasValue));
        }
        try {
            const data = await fetchXls(window.fileData);
            this.reader(data.slice(1));
        } catch (error) {
            console.error("ReaderItem: failed to load Excel data.", error);
        }
    }

    // 初始化swiper
    setSwiper() {
        const swiper = new Swiper('.mySwiper', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            speed: 1000,
            allowTouchMove: false,
        });

        const slides = document.querySelectorAll('.swiper-slide');
        const slidesBtn = document.querySelectorAll('.header-list p');

        function sleep(ms) {
            return new Promise((resolve) => {
                setTimeout(resolve, ms);
            });
        }

        function playScroll(item) {
            return new Promise((resolve) => {
                const content = item.querySelector('.auto-scroll-content');
                if (!content) {
                    resolve();
                    return;
                }
                content.style.transition = 'none';
                content.style.transform = 'translateY(0px)';
                requestAnimationFrame(() => {
                    const distance = content.scrollHeight - item.offsetHeight;
                    if (distance <= 0) {
                        setTimeout(resolve, 1000);
                        return;
                    }
                    const duration = distance * 30; // 设置快慢
                    content.style.transition = `transform ${duration}ms linear`;
                    content.style.transform = `translateY(-${distance}px)`;
                    setTimeout(() => { resolve(); }, duration);
                });
            });
        }

        async function playSlide(index) {
            const slide = slides[index];
            if (!slide) return;
            slide.style.opacity = '1';
            const items = slide.querySelectorAll('.auto-scroll-item');
            for (const item of items) {
                await playScroll(item);
            }
            await sleep(1000);
            slide.style.transition = 'opacity 1s';
            slide.style.opacity = '0';
            await sleep(1000);
            let next = swiper.activeIndex + 1;
            if (next >= slides.length) { next = 0; }
            slidesBtn.forEach((btn, key) => {
                if (key === next) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });
            swiper.slideTo(next);
        }
        swiper.on('slideChangeTransitionEnd', () => {
            playSlide(swiper.activeIndex);
        });
        if (slides.length) {
            playSlide(0);
        }

    }
    // 设置排名内容
    parseValue(str) {
        if (str === null || str === undefined || str === "") {
            return {
            type: "none",
            value: 0
            };
        }
        const rawValue = String(str).trim();
        const numberValue = Number(rawValue);
        if (Number.isNaN(numberValue) || numberValue === 0) {
            return {
            type: "none",
            value: 0
            };
        }
        return {
            type: numberValue > 0 ? "up" : "down",
            value: Math.abs(numberValue)
        };
    }



    // 设置CLASS的值
    setClass(value) {
        const map = {
            'DTC-NP': 'dtc-np-icon',
            'AMZ-ZLX': 'amz-zlx-icon',
            'TK-NP': 'tk-np-icon',
            'AMZ-NP': 'amz-np-icon',
            'MKT':'dtc-np-icon'
        };
        return map[value] || 'dtc-np-icon';
    }

    reader(data) {
        const toFiniteNumber = (value) => {
            const match = String(value).replace(/,/g, "").match(/-?\d+(?:\.\d+)?/);
            const number = match ? Number(match[0]) : 0;
            return Number.isFinite(number) ? number : 0;
        };
        const groupData = data.reduce((acc, item) => {
            const key = item[1];
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});

        // 按照利润率的平均值最高的排名
        const groupList = Object.entries(groupData).map(([type, list]) => {
            // 第5列（索引4）平均值
            const avg =
                list.reduce((sum, item) => sum + toFiniteNumber(item[4]), 0) / list.length;

            // 第4列总和（索引3）
            const user_gmv = list.reduce((sum, item) => sum + toFiniteNumber(item[3]), 0);

            // 第3列总和（索引2）
            const total_gmv = list.reduce((sum, item) => sum + toFiniteNumber(item[2]), 0);

            // 第7列总和（索引7）
            const integral_total = list.reduce((sum, item) => sum + toFiniteNumber(item[7]), 0);

            // 第8列总和（索引6）
            const integral_user = list.reduce((sum, item) => sum + toFiniteNumber(item[6]), 0);


            // 百分比
            const percent = total_gmv ? ((user_gmv / total_gmv) * 100).toFixed(1) : 0;

            const integral_percent = integral_total ? ((integral_user / integral_total) * 100).toFixed(1) : 0;

            return {
                type,
                avg: avg.toFixed(1),
                user_gmv,
                total_gmv,
                integral_total,
                integral_user,
                percent: `${percent}`,
                integral_percent: `${integral_percent}`,
                list
            };
        }).sort((a, b) => b.avg - a.avg);  // 按平均值倒序


         // 组别累计积分对比
        groupList.forEach((item) => {
            const otherClass = function setClass(value) {
                const map = {
                    'DTC-NP': 'dtc-np',
                    'AMZ-ZLX': 'amz-zlx',
                    'TK-NP': 'tk-np',
                    'AMZ-NP': 'amz-np',
                    'MKT':'dtc-np'
                };
                return map[value] || 'dtc-np';
            }

            var integral_dom = document.createElement("div");
            integral_dom.classList.add("item");
            integral_dom.classList.add(otherClass(item.type));
            integral_dom.innerHTML = `<p><span>${item.type}</span><em>${item.integral_user}</em></p>
                <div class="progress-bar">
                    <div class="progress-fill" style="width: ${item.integral_percent}%;"></div>
                </div>`;
            this.swiperSix.appendChild(integral_dom);
        });


        // 组别赛道
        this.groupTrack.forEach((item, index) => {
            if (item.number === 0 && item.value === 0) return;
            const dom = document.createElement("div");
            dom.classList.add("user-item");
            const gmvRateValue = item.count ? item.amount / item.count : 0;

            const gmvRate = (gmvRateValue * 100).toFixed(1);
            const profitHtml = item.value
                ? `
                <div class="number-item">
                    <p>利润率</p>
                    <span>${item.value}%</span>
                </div>
                <div class="progress">
                    <div class="progress-select" style="width:${item.value}%;"></div>
                </div>
                `: "";
            dom.innerHTML = `
                <div class="user-item ${item.type}">
                <div class="user-header">
                    <p>
                    <strong>${item.name}</strong>
                    <span>${item.name} · ${item.number} 人</span>
                    </p>
                    ${index === 0 ? "<em>LEADING</em>" : ""}
                </div>
                ${profitHtml}
                <div class="number-item">
                    <p>GMV</p>
                    <span>${gmvRate}%</span>
                </div>
                <div class="progress">
                    <div class="progress-select" style="width:${gmvRate}%;"></div>
                </div>
                </div>
            `;
            this.swiperOne.appendChild(dom);
        });



        // 全员进度墙
        const sorted = data.sort((a, b) => toFiniteNumber(b[4]) - toFiniteNumber(a[4]));
        sorted.forEach(item => {
            const targetGmv = toFiniteNumber(item[2]);
            const actualGmv = toFiniteNumber(item[3]);
            const profitRate = toFiniteNumber(item[4]);
            if (targetGmv === 0 && profitRate === 0) return;
            var dom = document.createElement("div");
            dom.classList.add("user-item");
            if (profitRate >= 100) {
                dom.classList.add("excess");
            } else if (profitRate >= 80) {
                dom.classList.add("success");
            }

            const gmvPercent = targetGmv === 0 ? 0 : actualGmv / targetGmv * 100;
            const gmvDisplayPercent = actualGmv > targetGmv ? 100 : gmvPercent.toFixed(1);
            const gmvDiffPercent = targetGmv === 0 ? 0 : Math.abs(actualGmv - targetGmv) / targetGmv * 100;

            var profitHtml = profitRate === 0 ? "" : `
                <div class="number-item"><p>利润率<em>${profitRate}%</em></p><span>${profitRate >= 100 ? '超' : '差'} <i>${profitRate > 100 ? profitRate - 100 : 100 - profitRate} %</i></span></div>
                <div class="progress"><div class="progress-select" style="width:${profitRate >= 100 ? 100 : profitRate}%;"></div></div>`;
            var gmvHtml = targetGmv === 0 ? "" : `
            <div class="number-item other"><p>GMV<em>${gmvDisplayPercent}%</em></p><span>${actualGmv >= targetGmv ? '超' : '差'} <i>${gmvDiffPercent.toFixed(1)}%</i></span></div>
                <div class="progress other"><div class="progress-select" style="width: ${gmvDisplayPercent}%;"></div></div>`;
            dom.innerHTML = `
                <div class="user-icon">
                    <cite class="${item[1]}">
                        <img src="${item[11]}" width="auto" height="auto" loading="lazy" />
                    </cite>
                    <p><strong>${item[0]}</strong><em class="${this.setClass(item[1])}">${item[1]}</em></p>
                    ${profitRate >= 100 ? '<div class="icon exceed">超额</div>' : profitRate >= 80 ? '<div class="icon success">达成</div>' : ''}
                </div>
                ${profitHtml}${gmvHtml}`
            this.swiperTwo.appendChild(dom);
        });

        // 前三名排行和全员排行榜
        const sortedList = data.sort((a, b) => b[6] - a[6]);

        // 前3个
        const topThree = sortedList.slice(0, 3);

        // 第一和第二交换
        [topThree[0], topThree[1]] = [topThree[1], topThree[0]];

        // 其余数据
        const otherList = sortedList.slice(3);

        topThree.forEach((item, index) => {
            var dom = document.createElement("div");
            dom.classList.add("user-top-item");
            dom.innerHTML = `
                <div class="fixed-info">
                    <span>${index === 1 ? '★ CHAMPION' : (index === 0 ? 'RANK 2' : 'RANK 3')}</span>
                    <i>${index === 1 ? '领跑积分榜 7 天' : `距离第一名少 ${topThree[1][6] - item[6]} Pts`} </i>
                </div>
                <cite>
                    <img src="${item[11]}" width="auto" height="auto" loading="lazy" />
                </cite>
                <p>${item[0]}</p>
                <em class="${this.setClass(item[1])}">${item[1]}</em>
                <div class="user-point">
                    <div class="point-item">
                        <span>累计获得：</span>
                        <div><i>${item[6]}</i> Pts</div>
                    </div>
                    <div class="point-item">
                        <span>累计消耗：</span>
                        <div><i>${item[5]}</i> Pts</div>
                    </div>
                </div>`;

            this.swiperThree.appendChild(dom);
        });

        otherList.forEach((item, index) => {
            var dom = document.createElement("div");
            dom.classList.add("table-body-item");
            const groupType = this.parseValue(item[8]);
            dom.innerHTML = `<span>${index + 4}</span>
                <span><em class="${groupType.type == 'none' ? 'level' : groupType.type}"></em>${groupType.value}</span>
                <span>${item[0]}</span>
                <span><i class="${this.setClass(item[1])}">${item[1]}</i></span>
                <span>${item[5]}</span>
                <span>${item[6]}</span>`;
            this.swiperFour.appendChild(dom);
        });

        // 一周黑马
        data.forEach((item, index) => {
            var dom = document.createElement("div");
            const groupType = this.parseValue(item[9]);
            dom.classList.add("rankings-item");
            dom.innerHTML = `<div class="rankings-user">
                <span class="number">${index + 1}</span>
                <cite>
                    <img src="${item[11]}" width="auto" height="auto" loading="lazy" />
                </cite>
                <P>${item[0]}</P>
                <i class="${this.setClass(item[1])}">${item[1]}</i>
            </div>
            <div class="rankings-number">
                <p><i>+${item[10]}</i> Pts</p>
                <span><em>${groupType.type == 'none' ? '' : (groupType.type == 'up' ? '↑' : '↓')} ${groupType.value}</em>位</span>
            </div>`;

            this.swiperFive.appendChild(dom);
        });
        if (typeof setAutoHeights === "function") {
            setAutoHeights();
        }
        requestAnimationFrame(() => {
            this.setSwiper();
        });
    }
}
if (!customElements.get('reader-item')) {
    customElements.define('reader-item', ReaderItem);
}




